import { Dispatch, SetStateAction } from "react";
import { WorkTitle } from "./workDetailPage/WorkTitle";
import NextItem from "./components/NextItem";
import BackButton from "./components/BackButton";
import { WorkTextSection } from "./workDetailPage/WorkTextSection";
import { MainImage } from "./workDetailPage/WorkMainImage";
import Navigator from './components/Navigation';
import { Waiting } from "./components/Waiting";
import { WorkFullImage } from "./workDetailPage/WorkFullImage";
import { useLanguage } from "./contexts/LanguageContext";
import work13goal1 from "./image/works/Work13goal1.webp";
import work13goal2 from "./image/works/work13goal2.webp";
import { WorkImage } from "./workDetailPage/WorkImage";
import { WorkVideo } from "./workDetailPage/WorkVideo";
import research1 from "./image/works/work13research1 1.webp";
import research2 from "./image/works/work13research2.webp";
import research3 from "./image/works/work13research3.webp";
import research4 from "./image/works/work13research4.webp";
import research5 from "./image/works/work13research5.webp";
import design1 from "./image/works/work13design1.webp";
import design2 from "./image/works/work13design2.webp";
import design3 from "./image/works/work13design3.webp";
import experiment1 from "./image/works/work13experiment1.webp"
import experiment2 from "./image/works/work13experiment2.webp"
import experiment3 from "./image/works/work13experiment3.webp"
import experiment4 from "./image/works/work13experiment4.webp"
import experiment5 from "./image/works/work13experiment5.webp"
import experiment6 from "./image/works/work13experiment6.webp"
import result1 from "./image/works/work13result1.webp"
import result1kor from "./image/works/work13result1kor.webp"
import result2 from "./image/works/work13result2.webp"
import result4 from "./image/works/work13result4.webp"
import result4kor from "./image/works/work13result4kor.webp"
import result5 from "./image/works/work13result5.webp"
import result5kor from "./image/works/work13result5kor.webp"
import { Divider, Hidden } from "@mui/material";
import thumbnail8 from './image/workThumbnails/thumbnail8.webp';
import { Wavedivider } from "./components/Wavedivider";
import { useMetaTags } from './utils/useMetaTags';
// import mainImage from './image/works/work13main';

//Personalized Ads consent


function Work13(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      const { language } = useLanguage();
      
      // 이미지들을 객체로 관리 (kor 버전 포함)
      const images = {
        work13goal1,
        work13goal2,
        research1,
        research2,
        research3,
        research4,
        research5,
        design1,
        design2,
        design3,
        experiment1,
        experiment2,
        experiment3,
        experiment4,
        experiment5,
        experiment6,
        result1,
        result1kor,
        result2,
        result4,
        result4kor,
        result5,
        result5kor,
      };
      
      // 언어에 따라 이미지 선택하는 함수
      const getImage = (imageName: string): string => {
        // 한국어일 때 kor 버전 이미지 찾기
        if (language === 'ko') {
          const korImageName = `${imageName}kor`;
          const korImage = images[korImageName as keyof typeof images];
          
          // kor 버전이 있으면 사용, 없으면 원본 사용
          if (korImage) {
            return korImage;
          }
        }
        
        // 영어이거나 kor 버전이 없으면 원본 이미지 사용
        return images[imageName as keyof typeof images] || '';
      };
      
      useMetaTags({
        title: 'Obtaining Consent for Personalized Advertising - Lynkim',
        description: 'Obtain personalized advertising consent from new users to serve tailored ads.',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
          <WorkTitle 
            title={'Obtaining Consent for Personalized Advertising'} 
            description={<div>Obtain personalized advertising consent from new users to serve tailored ads.</div>} 
            team={'Karrot'} 
            role={'UX Strategic Planning, Research, UXUI Design'} 
            period={'2024.10. - 2024.12.'}
            titleKo={'개인 맞춤형 광고 제공을 위한 동의 얻기'}
            descriptionKo={<div>개인화된 광고 제공을 위해 신규 가입자에게 최적의 동의율을 얻을 수 있는 UX를 연구하여 설계했습니다.</div>}
            teamKo={'당근'}
            roleKo={'UX 전략 기획, 리서치, UXUI 디자인'}
          />
        </div>   
        <WorkVideo video="/work13MainImage.mov" /> 
        <WorkTextSection title = 'Background' 
            description=
                {<div>Karrot has not explicitly obtained user consent for receiving personalized ads until now. However, to comply with regulations, we needed to explicitly request consent for personalized ads from new users upon signup.
                If a user declines consent for personalized ads, we will be unable to serve tailored advertisements, which could significantly decrease CTR and lead to a revenue drop of over 30%.
                To mitigate this impact, maximizing the opt-in rate for personalized ads was a critical challenge. Therefore, we aimed to develop effective ways to obtain consent from users who initially opted out during signup.
                </div>}
            subDescription={<div>
                당근은 지금까지 사용자로부터 개인 맞춤형 광고 수신에 대한 명시적인 동의를 받지 않았습니다. 그러나 관련 규제를 준수하기 위해, 신규 사용자부터는 회원가입 시 명시적으로 개인 맞춤형 광고에 대한 수신 동의를 받아야 했습니다.
                사용자가 개인 맞춤형 광고에 대한 동의를 거부할 경우, 맞춤형 광고를 제공할 수 없어 광고 클릭률(CTR)이 크게 감소할 수 있고, 이에 따라 광고 매출이 30% 이상 감소할 수 있습니다.
                이러한 영향을 최소화하기 위해, 동의율을 최대한 높이는 것이 중요한 과제였습니다. 회원가입 시 개인 맞춤형 광고에 동의하지 않은 사용자에게 효과적으로 동의를 얻을 수 있도록 하는 것을 목표했습니다.
            </div>

            }
                />    
         <WorkImage image={getImage('work13goal2')} isMaxheight={true} isbottomPadding={false} description={'An example of the ATT consent screen on Facebook.'}/>
        <WorkTextSection title = 'Goal' 
            description={<div>Our goal is to obtain consent for personalized advertising from the majority of users who newly sign up for the service. By obtaining consent for personalized advertising, we can display personalized ads rather than irrelevant ads, achieving higher ad click-through rates and effectively preventing revenue decline.
                <br/>However, the average ATT (App Tracking Transparency) opt-in rate for vertical service apps is below 35%, making it a highly ambitious goal to secure high consent rates from new users.</div>
            }
            subDescription={<div>
               우리의 목표는 서비스에 새로 가입하는 대부분의 사용자에게서 맞춤형 광고에 대한 수신 동의를 받는 것입니다. 맞춤형 광고에 수신 동의하면, 개인에게 관련없는 광고가 아닌 개인화된 광고를 보여줄 수 있어, 높은 광고 클릭률을 얻을 수 있고, 매출 감소를 효과적으로 방지할 수 있습니다.
                <br/>
                하지만 Vertical service app의 평균 ATT(App Tracking Transparency) 동의율은 35% 미만으로, 신규 가입자에게서 높은 동의율을 확보하는 것은 매우 도전적인 목표였습니다. 
            </div>}/>    
        <WorkImage image={getImage('work13goal1')} isMaxheight={true} isbottomPadding={false}/>
        <WorkTextSection title={'Strategy'} 
            description={
                <div>
                    We implemented a strategy to obtain consent from the largest number of users.
                    <br/>First, we take action at the moment when consent requests can reach the highest number of users during service use.
                    <br/>Second, we ensure that the request is made at a natural point that minimizes negative experiences while effectively persuading users to consent.
                    <br/>Lastly, we design effective UI by leveraging careful psychological principles to maximize the opt-in rate.
                </div>
            }
            subDescription={
                <div>
                    가장 많은 사용자로부터 동의를 얻을 수 있는 전략을 세웠습니다.
                    <br/>첫째, 서비스 이용 도중 가장 많은 사용자에게 가입을 요구할 수 있는 시점에 동의를 위한 액션을 합니다.
                    <br/>둘째, 부정적인 경험을 최소화하면서 효과적으로 동의를 유도할 수 있는 자연스러운 시점에 동의를 구합니다.
                    <br/>마지막으로, 세심한 심리학 원칙을 활용하여 동의율을 극대화하기 위해 효과적인 UI를 설계합니다.
                </div>
            }/>
        <WorkTextSection title={'Research'}
            description={
                <div>
                     To encourage more users to consent, we researched proven cases from other companies and psychological principles. Through this research, we gathered various insights that can be applied to screen design.
                </div>
            
                }
            subDescription={
                <div>
                    사용자들이 더 많이 동의하도록 유도하기 위해, 다른 기업들의 검증된 사례들과 심리학적 원칙들을 리서치했습니다. 이러한 리서치를 통해 적용할 수 있는 다양한 인사이트를 도출할 수 있었습니다.
                </div>
            }/>
        <WorkTextSection description={
            <div>
                <b>1. Optimal timing</b>
                    <br/>If the consent request is placed at the final stage of onboarding, right after a conversion action within the app (when the user has experienced the highest value), or following a positive engagement action, the likelihood of users opting in increases.
                    This is because people tend to perceive subsequent situations more positively after having a positive experience or after responding positively to a previous question.
                    <a style={{color:'var(--color-accent-primary)'}} href='https://www.psychologistworld.com/behavior/compliance/strategies/foot-in-door-technique' target="_blank" rel="noreferrer">(foot-in-the-door technique)</a>
            </div>
        }
        subDescription={
            <div>
                <b>1. 최적의 타이밍</b>
                    <br/>온보딩의 마지막 단계, 앱 내에서 전환 액션 직후(사용자가 가장 높은 가치를 경험한 시점), 또는 긍정적인 참여 액션 후에 동의 요청을 하면 사용자의 동의 가능성이 높아집니다.
                    이는 사람들이 긍정적인 경험을 한 후나 이전 질문에 긍정적으로 응답한 후에는 후속 상황을 더 긍정적으로 인식하는 경향이 있기 때문입니다.
                    <a style={{color:'var(--color-accent-primary)'}} href='https://www.psychologistworld.com/behavior/compliance/strategies/foot-in-door-technique' target="_blank" rel="noreferrer">(발을 문에 끼우는 기법)</a>
            </div>
        }/>
        <WorkImage image={getImage('research1')} isMaxheight={true} isbottomPadding={false}/>
        <WorkTextSection 
            description={
                <div>
                    <b>2. UI Design</b>
                    <br/>When a modal is designed to cover the entire screen, the opt-in rate is significantly higher than that of a half-view modal. This is because as people experience mental fatigue and depletion of willpower, they are more likely to make intuitive choices rather than logical decisions.
                </div>
            }
            subDescription={
                <div>
                    <b>2. UI 디자인</b>
                    <br/>모달이 전체 화면을 덮도록 설계되면 화면의 일부만 덮는 모달의 형태보다 동의율이 현저히 높았습니다. 이는 사람들이 정신적 피로와 의지력 고갈을 경험할 때 논리적 결정보다는 직관적 선택을 할 가능성이 높기 때문입니다.
                </div>
            }
        />
        <WorkImage image={getImage('research2')} isMaxheight={true} isbottomPadding={false}/>
        <WorkTextSection 
            description={
                <div>
                    Images can be identified faster than text, allowing users to process information more easily and quickly, which helps encourage consent. Listing and explaining the core value of the app's services alongside icons makes the benefits more visually prominent, drawing users' attention and increasing engagement.
                </div>
            }
            subDescription={
                <div>
                    이미지는 텍스트보다 빠르게 인식할 수 있어 사용자가 정보를 더 쉽고 빠르게 처리할 수 있으며, 이는 동의를 유도하는 데 도움이 됩니다. 앱 서비스의 핵심 가치를 아이콘과 함께 나열하고 설명하면 혜택이 시각적으로 더욱 두드러져 사용자의 주의를 끌고 참여도를 높입니다.
                </div>
            }
        />
        <WorkImage image={getImage('research3')} isMaxheight={true} isbottomPadding={false}/>
        <WorkTextSection 
            description={
                <div>
                    When persuasion relies on lengthy text, users tend to assume they will be shown more ads, leading to a higher opt-out rate.
                    <br/>Also, if the prompt is designed with a gray or dark background, users may perceive it as a technical or system requirement, prompting them to think logically about whether to consent rather than making an intuitive decision (engaging System 2 thinking). This increases the likelihood of opting out.
                    <br/>Additionally, placing the CTA horizontally rather than vertically can increase the opt-in rate by approximately 5%.
                </div>
            }
            subDescription={
                <div>
                    설득이 긴 텍스트에 의존할 때, 사용자들은 더 많은 광고를 보게 될 것이라고 가정하여 거부율이 높아집니다.
                    <br/>또한 프롬프트가 회색이나 어두운 배경으로 디자인되면, 사용자들이 이를 기술적이거나 시스템 요구사항으로 인식하여 직관적 결정보다는 논리적으로 동의 여부를 생각하게 됩니다(System 2 사고). 이 때문에 거부할 가능성이 높아집니다.
                    <br/>또한 CTA를 세로가 아닌 가로로 배치하면 동의율을 약 5% 증가한다는 결과가 있습니다. 
                </div>
            }
        />
        <WorkImage image={getImage('research4')} isMaxheight={true} isbottomPadding={false}/>
        <WorkTextSection 
            description={
                <div>
                    <b>3. The preferred language</b>
                    <br/>Using positive and personally relevant language (e.g., "better experience," "amazing," "relevant to you") can increase consent rates by more than three times.
                    <br/><em style={{color:'var(--color-text-subtle)'}}>Example: "We'll use your data to give you a more personalized ASOS experience and make our app even more amazing."</em>
                    <br/><br/>Avoid using words like "track" or "collect," as they can create a negative perception and reduce the likelihood of consent. Instead, focus on explaining and persuading users by highlighting how their data will be used to enhance their experience.
                </div>
            }
            subDescription={
                <div>
                    <b>3. 선호되는 언어</b>
                    <br/>긍정적인 언어와 개인에게 관련성 있는 언어("더 나은 경험", "놀라운", "당신에게 관련된")를 사용하면 동의율을 3배 이상 증가시킬 수 있습니다.
                    <br/><em style={{color:'var(--color-text-subtle)'}}>예시: "당신의 데이터를 사용해 더욱 개인화된 ASOS 경험을 제공하고 앱을 더욱 놀랍게 만들겠습니다."</em>
                    <br/><br/>"추적"이나 "수집"과 같은 단어는 부정적인 인식을 만들고 동의 가능성을 줄일 수 있으므로 피해야 합니다. 대신 데이터가 경험을 향상시키는 데 어떻게 사용될지 강조하여 사용자를 설명하고 설득하는 데 집중해야 합니다.
                </div>
            }
        />
        <WorkImage image={getImage('research5')} isMaxheight={true} isbottomPadding={false}/>
        <WorkTextSection title='Design'
            description={<div>
                Based on the insights discovered through research, we designed the basic structure of the bottom sheet.
                <br/><br/>
                <b>1. The bottom sheet should cover almost the entire screen.</b>
                <br/>Research has shown that a full-screen bottom sheet significantly increases the consent rate compared to a half-view. As people's willpower and mental energy deplete, they tend to make intuitive rather than logical decisions. When they have just completed a task or are preparing for one, they increasingly rely on instinct and look for ways to complete the current task with minimal effort. Therefore, a bottom sheet that fully covers the screen makes it easier to guide users toward clicking the prominent consent button, rather than allowing them to easily dismiss a half-view sheet.
                <br/><br/>
                <b>2. Place the close (X) button in the top-left corner.</b>
                <br/>Studies suggest that when the close button is positioned in the top-left corner, users subconsciously associate it with navigating back rather than exiting. This perception leads to fewer dismissals as users avoid the hassle of going back. Strategically placing the decline button in the top-left corner instead of the right can help reduce opt-out rates.
                <br/><br/>
                <b>3. Do not provide a decline button at the bottom.</b>
                <br/>While offering a decline button allows for selective consent, it also makes rejection an easy choice, which can lower the overall consent rate. Removing a clearly visible decline option helps maintain a higher opt-in rate.               
            </div>}
            subDescription={<div>
                연구를 통해 발견한 인사이트를 바탕으로 바텀시트의 기본 구조를 설계했습니다.
                <br/><br/>
                <b>1. 바텀시트는 거의 전체 화면을 덮어야 합니다.</b>
                <br/>기존의 연구에 따르면 전체 화면 바텀시트는 화면의 일부만 덮는 바텀시트보다 높은 동의율을 확보할 수 있습니다. 사람들의 의지력과 정신적 에너지가 고갈되면 논리적 결정보다는 직관적 결정을 내리는 경향이 있어, 작업을 완료했거나 준비 중일 때는 본능에 더 의존하고 최소한의 노력으로 현재 작업을 완료하는 방법을 찾습니다. 
                <br/><br/>
                <b>2. 닫기(X) 버튼을 왼쪽 상단 모서리에 배치합니다.</b>
                <br/>연구에 따르면 닫기 버튼이 왼쪽 상단 모서리에 위치할 때 사용자들은 무의식적으로 이를 종료가 아닌 뒤로 가기로 연관시킵니다. 이 인식은 사용자가 뒤로 가는 번거로움을 피하려 하기 때문에 더 적은 거부로 이어집니다. 거부 버튼을 오른쪽이 아닌 왼쪽 상단 모서리에 전략적으로 배치하면 거부율을 줄이는 데 도움이 됩니다.
                <br/><br/>
                <b>3. 하단에 거부 버튼을 제공하지 않습니다.</b>
                <br/>거부 버튼을 제공하면 선택적 동의가 가능하지만, 거부를 쉬운 선택으로 만들어 전체 동의율을 낮출 수 있습니다. 명확히 보이는 거부 옵션을 제거하면 더 높은 동의율을 유지하는 데 도움이 됩니다.
            </div>}
        />
        <WorkImage image={getImage('design1')} isMaxheight={false} isbottomPadding={false}/>
        <WorkFullImage image={getImage('design2')} isBackgroundColor={true} isMargin={true} isRoundedCorner={true} />
        <WorkTextSection description={<div>
            During the service signup flow, users are asked to consent to receiving personalized advertisements in the Terms of Service.
            If they decline, a re-consent prompt will be shown in a bottom sheet <b>upon completing the onboarding process and entering the main screen.</b>
            <br/>If the user also declines at this stage, the bottom sheet will reappear on the main screen <b>the next time they access the app after 7 days</b>, prompting them once again for consent.
       </div>}
       subDescription={<div>
            서비스 가입 플로우에서 이용약관에 개인 맞춤형 광고에 대한 수신 동의를 요청합니다. 하지만
            이를 거부할 경우, <b>온보딩 과정을 완료하고 메인 화면에 진입할 때</b> 바텀시트로 재동의를 요청하는 바텀시트을 노출하도록 설계했습니다.
            <br/>이 단계에서도 거부할 경우, <b>7일 후 앱에 다시 접속할 때</b> 메인 화면에서 바텀시트가 다시 나타나 한 번 더 동의를 요청합니다.
       </div>}/>
        <WorkFullImage image={getImage('design3')}/>
        <WorkTextSection
                title='Experiment'
                description={
                    <div>
                        We conducted experiments by formulating hypotheses based on five different strategies derived from psychological principles:
                        <br/><b>Effort</b> – Emphasizing the effort the service puts in for customers to encourage consent.
                        <br/><b>Psychological Accounting</b> – Framing benefits and losses in a way that leverages the natural tendency to avoid losses, making users aware of losses from not consenting to encourage consent.
                        <br/><b>Endowment Effect</b> – Framing as if users already own the benefits, so users perceive not receiving benefits as a loss, leveraging the psychology of wanting to avoid losses.
                        <br/><b>Social Norms</b> – Positioning the brand's values as widely recognized and important, encouraging users to participate.
                        <br/>By leveraging these psychological principles, we tested various approaches to maximize user consent.
                    </div>
                }
                subDescription={
                    <div>
                        심리학적 원칙에서 도출한 5가지 서로 다른 전략을 바탕으로 가설을 수립하여 실험을 진행했습니다:
                        <br/><b>노력</b> – 고객을 위해 서비스가 기울이는 노력을 강조하여 동의를 유도합니다.
                        <br/><b>심리적 회계</b> – 손실을 회피하려는 자연스러운 심리를 활용하여 동의하지 않을 시의 손실을 인지하도록 하여 동의를 유도합니다.
                        <br/><b>소유 효과</b> – 이미 혜택을 소유한 것처럼 프레이밍하여, 사용자가 혜택을 받지 못하는 것을 손실로 인식하게 하고, 손실을 피하고 싶은 심리를 이용합니다.
                        <br/><b>사회적 규범</b> – 브랜드의 가치를 사회적으로 이미 널리 인정받고 있고, 이 가치가 중요한 것으로 포지셔닝하여 사용자의 참여를 유도합니다.
                        <br/>이러한 심리학적 원칙을 활용하여 사용자 동의를 극대화하는 다양한 접근법을 테스트했습니다.
                    </div>
                }
            />
        <WorkFullImage image={getImage('experiment1')} />
        <Divider className = 'divider1'/>
        <div className='horizontal-layout'>
            <WorkTextSection 
                description={
                <div>
                    <b>Variant1. Emphasizing the Value of Personalized Content (While Hiding Ad-Related Information)</b>
                    <br/><br/>Research data shows that using <b>positive, personally relevant language</b> (e.g., better experience, amazing, relevant to you) increases consent rates by more than 3x. By framing the message around delivering a feed filled with personally relevant posts, we aim to reduce resistance and drive higher opt-in rates.
                    <br/>To enhance intuitive understanding, the UI <b>mimics the service's existing look and feel</b>, rather than using illustrations. This helps users immediately grasp the benefits of a personalized feed.
                    <br/>Additionally, loss aversion is a stronger psychological driver than the expectation of gains. Since Karrot's feed is primarily used for secondhand trading, one of its most valuable aspects is discovering great deals. By implying that users may <b>miss out on items they are interested in</b> if they opt out, we leverage the natural fear of loss to increase consent rates.

                </div>
            }
            subDescription={
                <div>
                    <b>Variant1. 개인화된 콘텐츠의 가치 강조 (광고 관련 정보를 숨김)</b>
                    <br/><br/>밝혀진 연구 데이터에 따르면 <b>긍정적이고 개인에게 관련성 있는 언어</b>(예: 더 나은 경험, 놀라운, 당신에게 관련된)를 사용하면 동의율이 3배 이상 증가합니다. 개인에게 관련된 게시물로 가득한 피드를 제공한다는 메시지를 전달하여 저항을 줄이고 더 높은 동의율을 유도하려고 합니다.
                    <br/>직관적으로 이해할 수 있도록 UI는 일러스트레이션 대신 <b>서비스의 기존 룩앤필을 차용</b>합니다. 이를 통해 사용자가 개인화된 피드의 혜택을 직관적으로 이해할 수 있도록 합니다.
                    <br/>또한 손실 회피는 이익을 기대하는 것보다도 강한 심리적 동기입니다. 당근의 피드는 주로 중고거래에 사용되므로, 사용자가 가장 원하는 가치는 좋은 게시글을 발견하는 것입니다. 사용자가 수신거부할 경우 <b>관심 있는 게시글을 놓칠 수 있다</b>고 암시하도록 하여, 손실에 대한 자연스러운 두려움을 활용해 동의율을 높입니다.

                </div>
            }
            />
            <div style={{maxWidth:'640px'}}><WorkFullImage image={getImage('experiment2')}/></div>
        </div>
        <Divider className = 'divider1'/>
        <div className='horizontal-layout'>
            <WorkTextSection 
                description={
                <div>
                    <b>Variant2. Emphasizing the Value of Personalized Content (Including Ad-Related Information)</b>
                    <br/><br/><b>Highlight key benefits with icons</b> to make them more visually prominent and easier to read, drawing user attention.
                    <br/>Use language like <em>"We'll improve your experience by showing only relevant ads"</em> to eliminate concerns about seeing unrelated ads.
                    <br/><b>Emphasize the additional value of receiving personalized benefits from nearby stores</b>, using a message like "You can see benefits from nearby stores that are helpful to you." This reflects research showing that emphasizing future benefits can significantly increase consent rates.
                    <br/><b>Avoid terms like <em>"tracking"</em> or <em>"collecting"</em></b>, as they can create negative perceptions and lead to lower opt-in rates. Instead, clearly explain how the data is used in a beneficial way. By framing it as "Your data is only used to recommend posts on Karrot", we build trust.
                </div>
            }
            subDescription={
                <div>
                    <b>Variant2. 개인화된 콘텐츠의 가치 강조 (광고 관련 정보를 포함)</b>
                    <br/><br/><b>아이콘으로 핵심 혜택을 강조</b>하여 시각적으로 더욱 두드러지고 읽기 쉽게 만들어 사용자가 주목하도록 했습니다.
                    <br/><em>"관련된 광고만 보이도록 개선해드려요"</em>와 같은 언어를 사용하여 관련 없는 광고를 볼 것에 대한 우려를 제거했습니다.
                    <br/><b>주변 가게로부터 개인화된 혜택을 받을 수 있다는 추가적인 가치를 강조</b>하며, "나에게 도움이되는 주변 가게들의 혜택을 볼 수 있어요"와 같은 메시지를 사용했습니다. 이는 미래에 제공받을 수 있는 혜택을 강조하면 동의율을 크게 높일 수 있다는 연구결과를 반영했습니다. 
                    <br/><b><em>"추적"</em>이나 <em>"수집"</em>과 같은 단어를 사용하지 않아</b>, 부정적인 인식을 만들고 낮은 동의율로 이어지는 것을 방지했고, 대신 수집한 데이터가 도움이되는 방식으로 사용된다는 것을 명확히 설명했습니다. "당근에서 게시물을 추천하는 데만 데이터를 사용합니다"로 표현하여 신뢰를 주었습니다.
                </div>
            }
            />
            <div style={{maxWidth:'640px'}}><WorkFullImage image={getImage('experiment3')}/></div>
        </div>
        <Divider className = 'divider1'/>
        <div className='horizontal-layout'>
            <WorkTextSection 
                description={
                <div>
                    <b>Variant3. Emphasizing Brand Values to Foster User Alignment and Participation</b>
                    <br/><br/>We emphasized the value that Karrot promotes — <b>connecting neighbors within the local community</b> — to make users feel that, by giving their consent, they are participating in and contributing to this shared value.
                    <br/>We also informed users that local business owners nearby are offering various benefits, and encouraged consent by highlighting that, by opting in, users can receive <b>relevant and useful benefits</b> in their neighborhood.
                </div>
            }
            subDescription={
                <div>
                    <b>Variant3. 브랜드 가치를 강조하여 사용자 참여 유도</b>
                    <br/><br/>당근이 지향하는 가치 — <b>지역 사회 내 이웃들을 연결</b> — 를 강조하여 사용자가 동의함으로써 이 공유 가치에 참여하고 기여한다는 느낌을 받도록 했습니다.
                    <br/>또한 근처 가게에서 다양한 혜택을 제공하고 있는 것을 사용자에게 알려, 동의했을 때 사용자가 <b>나에게 관련된 좋은 혜택</b>을 받을 수 있다고 느끼도록 하여 동의를 유도했습니다. 
                </div>
            }
            />
            <div style={{maxWidth:'640px'}}><WorkFullImage image={getImage('experiment4')} /></div>
        </div>
        <Divider className = 'divider1'/>
        <div className='horizontal-layout'>
            <WorkTextSection 
                description={
                <div>
                    <b>Variant4. Persuading Users with Service Efforts & Asking for Their Support</b>
                    <br/><br/>We adopt a strategy that <b>emphasizes efforts made for the user</b>, creating a sense of goodwill and encouraging users to participate. Users are more likely to respond positively when they recognize that a service is making an effort for them.
                    <br/>Providing emotional images and messages can evoke positive feelings, which in turn increases the likelihood of positive responses. Therefore, we use visuals that depict warm and meaningful transactions within the service.
                </div>
            }
            subDescription={
                <div>
                    <b>Variant4. 서비스 노력을 강조하여 사용자 설득</b>
                    <br/><br/><b>사용자를 위해 서비스가 들인 노력을 강조</b>하는 전략으로 사용자가 동참하고자 하는 감정을 조성하도록 했습니다. 사용자는 서비스가 자신을 위해 노력하고 있다는 것을 인식할 때 긍정적으로 응답할 가능성이 높았습니다.
                    <br/>감정적인 이미지와 메시지를 제공하여 긍정적인 감정을 불러일으키고, 이는 긍정적인 응답을 하도록 하는 가능성을 높입니다. 따라서 서비스 내에서 따뜻하고 의미 있는 거래를 묘사하는 시각적 요소를 사용했습니다. 
                </div>
            }
            />
            <div style={{maxWidth:'640px'}}><WorkFullImage image={getImage('experiment5')}/></div>
        </div>
        <Divider className = 'divider1'/>
        <div className='horizontal-layout'>
            <WorkTextSection 
                description={
                <div>
                    <b>Variant5. Implying the Negative Scenario That Unnecessary Ads</b>
                    <br/><br/>We adopt a strategy that <b>highlights the benefit of reducing excessively repetitive ads.</b> By reminding users that they may experience inconvenience if they do not agree, we can encourage them to consent.
                    <br/>We also clarify that collected information is only used for recommending posts on Karrot, alleviating concerns about personal information when consenting.
                    </div>
            }
            subDescription={
                <div>
                    <b>Variant5. 불필요한 광고의 부정적 경험을 암시하는 전략</b>
                    <br/><br/><b>과도하게 반복되는 광고를 줄이는 혜택을 강조</b>하는 전략을 사용했습니다. 동의하지 않으면 광고로 인해 불편함을 경험할 수 있다고 사용자에게 상기시켜 동의를 유도했습니다.
                    <br/>또한 수집한 정보는 당근에서 게시물을 추천하는 데만 사용된다는 것을 명확히 하여, 동의했을 때의 개인정보에 대한 우려를 완화했습니다.
                    </div>
            }
            />
            <div style={{maxWidth:'640px'}}><WorkFullImage image={getImage('experiment6')} /></div>
        </div>
        <Divider className = 'divider1'/>
        <WorkTextSection title='Experiment Analysis'
            description={
                <div>
                    Through experiments, we found effective strategies for obtaining user consent for personalized ads:
                    <br/><br/>
                    1. <b>Emphasizing potential losses (inconvenient situations)</b> led to a higher consent rate.
                    <br/>
                    2. Rather than hiding negative content, clearly presenting and persuading users about <b>potentially unpleasant or inconvenient aspects</b> resulted in a higher consent rate.
                </div>
            }
            subDescription={
                <div>
                    실험을 통해 개인 맞춤형 광고의 동의를 얻기 위한 효과적인 전략을 찾을 수 있었습니다:
                    <br/><br/>
                    1. <b>잠재적 손실(불편한 상황)을 강조</b>하는 것이 더 높은 동의율로 이어졌습니다.
                    <br/>
                    2. 부정적인 내용을 숨기는 것이 아니라 <b>잠재적으로 불쾌하거나 불편한 측면</b>을 오히려 명확히 제시하고 설득하는 것이 더 높은 동의율을 가져왔습니다.
                </div>
            }
        />
        <WorkImage image={getImage('result1')} isMaxheight={false} isbottomPadding={true} isRoundedCorner={false} />
        <WorkTextSection 
            description={
                <div>
                    When we observed that the click-through rate of Experiment Group 1 was <b>more than twice</b> that of Experiment Group 2, we discovered that clearly explaining and persuading users about potentially <b>uncomfortable topics (such as ad personalization and the use of personal data)</b> had a positive impact on obtaining consent, rather than hiding this information.
                </div>
            }
            subDescription={
                <div>
                    실험 그룹 1의 클릭률이 실험 그룹 2보다 <b>2배 이상</b> 높다는 것을 확인했을 때, 잠재적으로 <b>불편한 주제(광고 개인화 및 개인 데이터 사용 등)</b>에 대해 명확히 설명하고 설득하는 것이 이러한 정보를 숨기는 것보다 동의를 얻는데 오히려 긍정적인 영향을 미친다는 것을 발견했습니다.
                </div>
            }
        />
        <WorkFullImage image={getImage('result2')} isMargin={false} />   
        {/* <div className='image-center margin48 horizontal-layout'>
         <WorkFullImage image={result2} isMargin={false} isBottomMargin={true} />   
         <WorkFullImage image={result3} isMargin={false} isBottomMargin={true} />   
        </div>   */}
      <WorkTextSection 
            description={
                <div>
                    Additionally, the experiment group with the highest consent rate, Experiment Group 5, adopted a <b>"psychological accounting"</b> strategy, which emphasized the inconvenience of not giving consent rather than highlighting the value users would gain.
                    <br/>
                    In this experiment, the content suggested that refusing to consent to personalized ad delivery could lead to <b>irrelevant ads being shown repeatedly</b>, implying a negative scenario.
                    <br/>
                    Although we were initially concerned that emphasizing potential inconvenience might cause negative reactions, the results showed that leveraging users' tendency to avoid losses was significantly more effective in obtaining consent.
                </div>
            }
            subDescription={
                <div>
                    또한 가장 높은 동의율을 보인 실험 그룹 5는 <b>"심리적 회계"</b> 전략을 채택했는데, 이는 사용자가 얻을 가치를 강조하는 것보다 동의하지 않을 때의 불편함을 강조한 것입니다.
                    <br/>
                    이 실험에서 개인 맞춤형 광고 수신에 동의하지 않으면 <b>관련 없는 광고가 반복적으로 표시될 수 있다</b>는 것을 명시하여 부정적인 시나리오를 암시했습니다.
                    <br/>
                    잠재적 불편함을 강조하는 것으로 인해 부정적인 반응을 야기할 수 있다고 우려했지만, 결과적으로 사용자의 손실 회피 심리를 활용하는 것이 수신동의 획득에 훨씬 더 효과적이라는 것을 확인할 수 있었습니다. 
                </div>
            }
        />
        <WorkVideo video="/work13result3.mov" /> 
        

      <WorkTextSection description={
        <div>
            When users declined consent after viewing the bottom sheet, it was repeatedly shown again <b>after seven days</b> when they access the app, requesting consent once more.
            <br/>
            Analyzing Group 5, which had the highest consent rate, we observed that the consent rate (CTR) gradually increased with each repetition and <b>converged to around 39% after four or more exposures.</b>
            <br/>
            However, displaying the bottom sheet more than five times no longer changes the consent rate and is ineffective. <b>Showing it more than four times to a single user does not yield additional benefits and may instead cause fatigue in their service experience, so we concluded that displaying it more than four times is ineffective.</b>
        </div>
      }
      subDescription={
        <div>
            사용자가 바텀시트를 보고 수신에 대해 거부하면 <b>7일 후</b> 앱에 진입했을 시, 다시 반복적으로 바텀시트를 표시하여 동의를 요구하도록 했습니다 
            <br/>
            가장 높은 동의율을 보인 그룹 5를 분석한 결과, 반복적으로 바텀시트를 노출할 때 동의율(CTR)이 점진적으로 증가하여 <b>4회 이상 노출 후 약 39%로 수렴</b>하는 것을 확인할 수 있었습니다.
            <br/>
            하지만 바텀시트를 5회 이상 표시하는 것은 더이상 동의율의 변화를 가져오지 않아 효과가 없었습니다. <b>단일 사용자에게 4회 이상 표시하는 것은 추가적인 이익을 가져다주지 않으며 오히려 서비스 경험에서 피로감을 야기할 수 있어, 4회 이상 표시하는 것은 효과가 없다고 결론내렸습니다.</b>
        </div>
      }
      />
      <WorkFullImage image={getImage('result5')} isMargin={true} isBottomMargin={true}/> 
      <WorkTextSection title='Result'
        description={
            <div>
                Through the above experiments, we decided to display the Bottom Sheet for Variant5 <b className="textGradient">up to 4 times every 7 days upon app launch</b>. Additionally, after 4 exposures, the exposure limit will be reset 90 days after the last exposure, allowing repeated exposures to resume.
            </div>
        }
        subDescription={
            <div>
                위 실험을 통해, Variant5의 바텀시트를 <b className="textGradient">앱 실행 시 7일마다 최대 4회까지</b> 표시하는 것으로 결정했습니다. 또한 4회 노출 후, 마지막 노출로부터 90일 후에 노출 제한이 재설정되어 반복 노출을 재개할 수 있도록 했습니다.
            </div>
        }
      />
      <div style={{ padding: " 0px 48px"}}><Wavedivider/></div>
      <WorkTextSection title='Impact'
            description={
                <div>
                    <b>Consent Rate of Personalized Ads</b>
                    <br/>As a result of the experiment, approximately 76% of users consented to receiving personalized ads at the time of sign-up.
                    <br/>Additionally, users who initially declined at signup reconsented via the bottom sheet, increasing the overall consent rate for personalized ads to about 80%.
                    <br/>
                    Therefore, if Variant5 is applied to all users, <b>we can maintain a consent rate of approximately <b className="textGradient">82%</b> among new sign-ups.</b>
                    <br/><br/>
                    
                    <b>Revenue Increase</b>
                    <br/>In Variant5, revenue per user saw the highest increase, <b>rising by approximately <b className="textGradient">27–29%.</b></b>
                    <br/>
                    The higher the consent rate for personalized ads, the higher the ad revenue. All experimental groups showed an increase in revenue compared to the control group. By utilizing user information, we were able to deliver ads with a higher expected click-through rate, resulting in an actual increase in CTR.
                    <br/>Therefore, we can expect that as the consent rate for personalized ads increases, it will continue to have a positive impact on revenue.</div>
            }
            subDescription={
                <div>
                    <b>개인 맞춤형 광고 동의율</b>
                    <br/>실험 결과, 약 76%의 사용자가 회원가입 시 개인 맞춤형 광고 수신에 동의했습니다.
                    <br/>또한 회원가입 시 처음에 거부한 사용자들이 바텀시트를 통해 재동의하여, 개인 맞춤형 광고의 전체 동의율이 약 80%로 증가했습니다.
                    <br/>
                    따라서 Variant5를 모든 사용자에게 적용하면, <b>신규 가입자의 약 <b className="textGradient">82%</b>의 동의율을 유지할 수 있습니다.</b>
                    <br/><br/>
                    
                    <b>매출 증가</b>
                    <br/>Variant5에서는 사용자당 매출이 가장 높은 증가를 보였으며, <b>약 <b className="textGradient">27-29%</b> 증가했습니다.</b>
                    <br/>
                    개인 맞춤형 광고 동의율이 높을수록 광고 매출도 높아집니다. 모든 실험 그룹이 대조군 대비 매출 증가를 보였습니다. 사용자 정보를 활용하여 더 높은 예상 클릭률을 가진 광고를 전달할 수 있었고, 이는 실제 CTR 증가로 이어졌습니다.
                    <br/>따라서 개인 맞춤형 광고 동의율이 증가할수록 매출에 지속적인 긍정적 영향을 미칠 것으로 예상됩니다.</div>
            }
        />
        
        <WorkFullImage image={getImage('result4')} isMargin={true} isBottomMargin={true}/> 
        <NextItem to='/Work8' thumbnail={thumbnail8} nextProjectTitle='A Bidding System in Search Ads'/>
        <BackButton/>
        <div style={{ height: "400px" }} />
        </>
      )
  }
  
  export default Work13;
